import React from 'react';
import { StringField } from '../../../types/types';

export type TPrivacyContentFieldItem = {
  id: string;
  name: string;
  displayName: string;
  fields: {
    contentDetail?: StringField;
    accordionContentTitle?: StringField;
    accordionContentDetail?: StringField;
    templateId: string;
  }
}

export type TPrivacyContentItems = {
  id: string;
  name: string;
  displayName: string;
  fields: {
    anchorContentTitle: StringField;
    templateId: string;
    items: TPrivacyContentFieldItem[];
  }
};

export type TPrivacyContent = {
  privacyStatementTitle: StringField;
  languageTitle: StringField;
  changeLanguageTitle: StringField;
  templateId: string;
  items: TPrivacyContentItems[];
};

export type TLanguageCollection = {
  [x: string]: string;
}

export type TPrivacyStatementFields = {
  changeLanguageTitle: StringField;
  languageCollection: Array<TLanguageCollection>;
  privacyContent: TPrivacyContent;
};

export type TPrivacyStatementProps = {
  componentName?: string;
  fields?: TPrivacyStatementFields;
  activeItem?: number;
  setActiveItem?: React.Dispatch<React.SetStateAction<number>>
};

export enum InnerContentTypes {
  RichText = "{7C968F99-5147-4541-8A46-09666FEDBD16}",
  Accordion = "{E78CD344-B1F8-4B4B-95E9-2C00DEEA10A4}",
}

export type TDropdownProps = {
  languageCollection: Array<TLanguageCollection>;
  changeLanguageTitle: string;
  languageTitle: string;
}

export type TAccordionProps = {
  accordionContentTitle?: StringField;
  accordionContentDetail?: StringField;
}

export type TSectionTabsProps = {
  contentWrapperRef:  React.MutableRefObject<HTMLDivElement | null>;
  privacyContentItems: TPrivacyContentItems[];
}

export type TMobileNavigationBarProps = {
  privacyContentItems: TPrivacyContentItems[];
}
